import React from 'react';
import { Link } from 'react-router-dom';
import { useLang } from '../contexts/LanguageContext';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_unified-services-hub-5/artifacts/m3halsur_image.png';

const Logo = ({ size = 'md', showTagline = true }) => {
  const { t } = useLang();
  // Width values are tuned so the logo image matches the slogan text width below it.
  const widths   = { sm: 'w-[200px]', md: 'w-[280px]', lg: 'w-[340px]' };
  const tagSizes = { sm: 'text-[12px]', md: 'text-[15px]', lg: 'text-[17px]' };

  return (
    <Link to="/" translate="no" className="inline-flex flex-col items-start group shrink-0 leading-none notranslate" data-testid="site-logo">
      <div className={`transition-transform duration-300 group-hover:scale-[1.02] flex flex-col ${widths[size]}`}>
        <img
          src={LOGO_URL}
          alt="Land Drafters — Global Engineering & CAD Services"
          className="w-full h-auto object-contain drop-shadow-sm bg-transparent"
        />
        {showTagline && (
          <span
            className={`mt-1 italic tracking-tight font-semibold ${tagSizes[size]} text-center bg-gradient-to-r from-[#16a34a] via-amber-500 to-orange-600 bg-clip-text text-transparent whitespace-nowrap drop-shadow-[0_1px_1px_rgba(0,0,0,0.35)]`}
            data-testid="logo-tagline"
          >
            {t('tagline')}
          </span>
        )}
      </div>
    </Link>
  );
};

export default Logo;
